<div class="icbc-alert-box icbc-alert-box-information">
    <mat-icon class="icbc-alert-icon">info_outline</mat-icon>
    <span>{{message}}</span>
</div>
